import { useEffect, useState } from "react";
import { useRouter } from "next/router";

const usePreviousUrl = () => {
  const router = useRouter();
  const [previousUrl, setPreviousUrl] = useState<string | null>(null);
  useEffect(() => {
    const handleRouteChange = (url: string) => {
      setPreviousUrl(router.asPath);
    };

    router.events.on("routeChangeStart", handleRouteChange);
    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router.asPath]);

  return previousUrl;
};

export default usePreviousUrl;
